import {Provider} from '@oilstone/container';
import Cookie from "@/services/cookie";

export default new Provider().register(container => {
    container.singleton('cookie', () => {
        return Cookie.make();
    });
}).boot(container => {
    const cookieState = JSON.parse(container.resolve('cookie').get('cookieConsent') || '{}');

    const store = container.resolve('vuexStore');

    store.dispatch('tracker/setHasCookiePreference', typeof cookieState.marketing !== 'undefined' && typeof cookieState.analytics !== 'undefined');
    store.dispatch('tracker/setMarketing', !!cookieState.marketing);
    store.dispatch('tracker/setAnalytics', !!cookieState.analytics);
    store.dispatch('tracker/updateGtag');
});
